import { DropdownList } from "react-widgets";
import { ReactComponent as ArrowDown } from "../../../../assets/elevva-pro-icons/arrowDown.svg";

const ComponentSelectFrecuency = ({
  data,
  doAction,
  defaultData,
  selectValue = "",
  onSearchTermChange,
}) => {
  return (
    data &&
    data.length > 0 && (
      <DropdownList
        busy
        busySpinner={<ArrowDown></ArrowDown>}
        style={{
          width: "100%",
          margin: "auto 0",
        }}
        defaultValue={defaultData}
        className={"input-style-elevva-graphics"}
        id="optionsFrecuency"
        placeholder={"Seleccionar"}
        data={data?.map((memb) => ({
          id: memb.id,
          name: memb.name,
          valor: memb.valor,
        }))}
        onSearch={(searchTerm) => {
          if (onSearchTermChange) onSearchTermChange(searchTerm);
        }}
        dataKey="id"
        textField="name"
        onChange={(value) => doAction(value.valor)}
        renderListItem={({ item }) => (
          <div className="w-100" style={{ borderBottom: "1px solid #9DACBD" }}>
            <span
              style={{
                fontSize: "calc(.4rem + .4vw)",
                color:
                  item.valor == selectValue
                    ? "white"
                    : "var(--elevvaTextTitle)",
              }}
            >
              {item.name}
            </span>
          </div>
        )}
      />
    )
  );
};
export default ComponentSelectFrecuency;
